import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuthStore } from '@/lib/auth/store';
import { useCreateAgentGroup } from '../api';
import { AgentGroupForm } from './AgentGroupForm';

export function CreateGroupAgentPage() {
  const navigate = useNavigate();
  const userId = useAuthStore((s) => s.userId);
  const create = useCreateAgentGroup();

  return (
    <AgentGroupForm
      mode="create"
      initialGroupName=""
      initialAgents={[]}
      isPending={create.isPending}
      onSubmit={({ groupName, agents }) => {
        create.mutate(
          { userId: Number(userId), groupName, agents },
          {
            onSuccess: (res) => {
              if (res?.message === 'Parameters Incorrect') {
                toast.error(res.message);
                return;
              }
              toast.success(res?.message ?? 'Agent group created');
              navigate('/group-agent-list');
            },
            onError: () => toast.error('Could not create the agent group.'),
          },
        );
      }}
    />
  );
}
